import { app_state, pp, notify, pluralize, e /*  hasRole, pp_user, link, formatDate */ } from '@helpers'

export const useUserStore = {

    state: ()/* : State */ => ({

        // openActionsDialog: false,

        loading: false,

        filter: '',
        filter_min_length: 2,
        pagination: { rowsPerPage: 20/*same in Controller*/, rowsNumber: 20, page: 1, sortBy: 'name', descending: false }, // 3,5,7,10,15,20,25,50 - same in UsersController() (mini 1 de plus au début pour rowsNumber)

        // current_page: 1,
        roles_selected: [],
        // status_selected: null,
        show_trashed: 0,


        controlPassword_OK: false,

        knobPasswordStrength: 0,
        knobPasswordText: '',
        knobPasswordColor: 'transparent',


        show_checkbox_selectors: false,
        selected: {},
        select_all: false,


        count_notifies: 0, // used in Components/partials/Notifies.vue

        // options_status: [
        //     { label: 'XXX en attente d\'approbation',     value: 'xxx-unvalidate',           sublabel: "(suite à leurs inscriptions)" },
        //     { label: 'YYY en attente d\'approbation',     value: 'yyy-unvalidate',           sublabel: "(suite à leurs inscriptions)" },
        // ],
    }),

    getters: {

        getUserName(/* state */){

            return (user_id) => _.find(app_state().all_users, {value: Number(user_id)})?.label ?? null
        },

        getDrivers(){

            return () => _.filter(app_state().all_users, u => _.includes(u.roles, 5)) ?? []
        },

    },

    actions: {

        async requestList(/* pagination */){//, filter}){

            this.show_checkbox_selectors = false
            this.select_all = false
            this.selected = {}

            // this.loadingTable = true;

    // log('in requestList() - pagination, filter', pagination, filter)//, 'this.pagination', this.pagination)

                // if(_.size(this.roles_selected)){
                //     this.filter = '';
                // }
            // if( this.pagination.page != this.this.pagination.page				// si c'est pas la même page demandée
            // || (filter.length >= 3 || filter.length == 0)			// si le filtre à 3 lettres  ou aucune(reset)
            // || this.pagination.descending != this.this.pagination.descending	// si c'est pas le même tri demandé
            // || this.pagination.sortBy != this.this.pagination.sortBy			// si c'est pas le même ordre demandé
            // ){
            if( (_.size(this.filter) >= this.filter_min_length || _.size(this.filter) == 0)			// si le filtre à mini. 2 lettres  ou ide(reset)
            ){
                this.loading = true;
                    // this.pagination.page = 1

                if(_.size(this.filter) >= this.filter_min_length){

                    this.pagination.page = 1
                    // this.show_trashed = 0
                    // this.roles_selected = []
                }

                // proto.$page.props.items = []

                // this.pagination = pagination
    // log(this, proto())
                // await axios.get(route('users.index'), {
                    // params: {
                await proto.$inertia.get(route('users.index'), {
                    page:           this.pagination.page,//this.current_page,//
                    sortby:         this.pagination.sortBy,
                    order:          this.pagination.descending,
                    filter:         this.filter,
                    paginate:       this.pagination.rowsPerPage,
                    roles:          this.roles_selected,
                    // status:         this.status_selected,
                    show_trashed:   this.show_trashed,
                }
                ,{
                    onSuccess:(res)=>{
            // log('in user action requestList() success',res)
                        this.pagination.rowsNumber   = res.props.items.total//pp().users.total
                        // this.pagination        = pagination
                        // this.loading           = false;
                    },
                    // onError:()=>{
                    //     this.loading           = false;
                    // }
                })


                this.loading           = false;
                // .then((res)=>{
                //                 this.pagination.rowsNumber   = res.props.users.total,//pp().users.total
                //                 this.pagination        = pagination
                //                 // this.loading           = false;

                //     // log('in requestList() after request',this.pagination, fn.route().current(), fn.route().params)
                // })
                // .catch(error=>{
                //     notify('warning', "Impossible de sortir les données.")
                // })
                // this.loading           = false;

                // this.openActionsDialog = false
            }
        },




        reSendUserInfos(user_id){

            // var users_ids = _.keys(_.find(this.selected, v => v))
            var users_ids = user_id ? [user_id] : []

            if(!user_id){
                _.filter(this.selected, (v, id) => {
                    if(v){ users_ids.push(Number(id)) }
                })
            }
            // log(this.selected, users_ids)

            $q.dialog({title: 'Information...',message: "<p>Cette action n'enverra que l'<b>e-mail</b> de l'utilisateur...</p><p>Son Mot de Passe est crypté, et donc impossible à connaître...</p>",html: true,cancel:true})
                .onOk(()=>{

                    axios.post(route('re-send-users-infos'), {users_ids: users_ids})
                        .then(()=>{

                            notify('positive', pluralize(_.size(users_ids), 'E-mail')+" en cours d'envoi.")

                            this.show_checkbox_selectors = false
                            this.select_all = false
                            this.selected = {}
                        })
                        .catch((err)=> e('warning', 'Oooops... Une erreur est survenue.'))
            })
        },



        /**
         * Activer/Désactiver un User
         * @param Integer user_id

        disabled(user){

            var member_getted = pp().member_getted

            var status = user.inactive ? 'Actif' : 'Inactif'

            var datas_dialog = {title: 'Confirmation...', message:`<p>Vous êtes sur le point de ${member_getted ? 'le' : 'vous'} déclarer comme « ${status} »...</p>`,
                        html: true, ok: {label: `Déclarer ${status}`, color:'green-8', noCaps: true}, cancel: true }

            if( ! user.inactive){
                datas_dialog.prompt = {
                    label: "Date de début d'inactivité",
                    hint: 'format: JJ/MM/AAAA',
                    model: false,type: 'text',
                    mask: '##/##/####', maxlength: 10,
                }
            }

            $q.dialog(datas_dialog)
                .onOk((date)=>{

                    if( ! date && ! user.inactive){
                        return notify("info","Merci d'indiquer une date de début d'inactivité au format : JJ/MM/AAAA")
                    }
                    proto.$inertia.post(route(`user.disabled`), {user_id: user.id, date: date})
                })
        },  */

    }
}
